// ==========================================
// ARQUIVO: dateUtils.ts (ou similar)
// ==========================================

/**
 * Formats an ISO string to "DD/MM/YYYY HH:MM:SS".
 */
export function formatIsoDate(isoString: string): string {
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return '-'; // Ou tratamento de erro adequado

  const pad = (n: number) => n.toString().padStart(2, '0');

  return (
    `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  );
}

// ==========================================
// ARQUIVO: durationUtils.ts (ou similar)
// ==========================================

// Função auxiliar (privada ou exportada se necessário)
function getDurationUnits(totalSeconds: number) {
  // ... (mesma lógica matemática de antes: secondsInMonth, etc)
  const secondsInMinute = 60;
  const secondsInHour = 3600;
  const secondsInDay = 86400;
  const secondsInMonth = 2592000;

  let remaining = totalSeconds;

  const months = Math.floor(remaining / secondsInMonth);
  remaining %= secondsInMonth;

  const days = Math.floor(remaining / secondsInDay);
  remaining %= secondsInDay;

  const hours = Math.floor(remaining / secondsInHour);
  remaining %= secondsInHour;

  const minutes = Math.floor(remaining / secondsInMinute);
  const seconds = Math.floor(remaining % secondsInMinute);

  return { months, days, hours, minutes, seconds };
}

/**
 * Formats a duration in seconds to a verbose string (e.g., "2 horas 30 minutos").
 */
export function formatDurationVerbose(totalSeconds: number): string {
  const units = getDurationUnits(totalSeconds);
  const parts: string[] = [];

  if (units.months > 0)
    parts.push(`${units.months} mês${units.months > 1 ? 'es' : ''}`);
  if (units.days > 0)
    parts.push(`${units.days} dia${units.days > 1 ? 's' : ''}`);
  if (units.hours > 0)
    parts.push(`${units.hours} hora${units.hours > 1 ? 's' : ''}`);
  if (units.minutes > 0)
    parts.push(`${units.minutes} minuto${units.minutes > 1 ? 's' : ''}`);

  if (parts.length === 0 || units.seconds > 0) {
    parts.push(`${units.seconds} segundo${units.seconds !== 1 ? 's' : ''}`);
  }

  return parts.slice(0, 3).join('\n ');
}

/**
 * Formats a duration in seconds to a short string (e.g., "02h 30m").
 */
export function formatDurationShort(totalSeconds: number): string {
  const units = getDurationUnits(totalSeconds);
  const parts: string[] = [];
  const pad = (n: number) => n.toString().padStart(2, '0');

  if (units.months > 0)
    parts.push(`${units.months} mês${units.months > 1 ? 'es' : ''}`);
  if (units.days > 0) parts.push(`${units.days}d`);
  if (units.hours > 0) parts.push(`${pad(units.hours)}h`);
  if (units.minutes > 0) parts.push(`${pad(units.minutes)}m`);

  if (parts.length === 0 || units.seconds > 0) {
    parts.push(`${pad(units.seconds)}s`);
  }

  return parts.slice(0, 3).join(' ');
}
